import { connect } from "react-redux";

import { Header as HeaderElt, HeaderStateProps } from "./presenter";
import { GlobalState } from "@app/models/state";
import {
    getIsAuthenticated,
    canViewUser,
    getCurrentUser,
    getCurrentOrganisation,
} from "@auth/selectors";
import { canViewDelivery } from "@deliveries/selectors";
import { canCreateAlbum } from "@music/selectors";
import { canViewReport, canGenerateReport } from "@reports/selectors";
import { canViewGlobalStats, canViewSales } from "@sales/selectors";
import { canViewBundle } from "@upload/selectors";
import { compose } from "@util/compose";
import { canViewPlaylist } from "@vendor/selectors";

function mapStateToProps(state: GlobalState): HeaderStateProps {
    return {
        authenticated: getIsAuthenticated(state),
        canCreateAlbum: canCreateAlbum(state),
        canViewUser: canViewUser(state),
        canViewDelivery: canViewDelivery(state),
        canViewReport: canViewReport(state),
        canGenerateReport: canGenerateReport(state),
        canViewBundle: canViewBundle(state),
        canViewPlaylist: canViewPlaylist(state),
        canViewGlobalStats: canViewGlobalStats(state),
        canViewSales: canViewSales(state),
        user: getCurrentUser(state),
        organisation: getCurrentOrganisation(state),
    } as HeaderStateProps;
}

const Header = compose<HeaderStateProps, {}>(
    connect(mapStateToProps, null),
)(HeaderElt);

export { Header };
